import {useStorage} from "@/api/storage/local";

const STORAGE_KEY = "quiz_profile";

export default {
    namespaced: true,
    state: {
        model: {}
    },
    getters: {
        model: state => state.model
    },
    mutations: {
        setModel: (state, model) => state.model = model,
        updateStorage: state => useStorage().set(STORAGE_KEY, state.model)
    },
    actions: {
        fetch(context, model) {

            model = model || useStorage().get(STORAGE_KEY, {});
            context.commit("setModel", model);
        },
        setModel(context, model) {

            context.commit("setModel", model);
            context.commit("updateStorage");
        },
        clear(context) {

            context.commit("setModel", {});
            context.commit("updateStorage");
        }
    }
}